import ApplicationController from "../application_controller";

// Based on the lite-youtube-embed web component: https://github.com/paulirish/lite-youtube-embed/tree/master
export default class YtEmbedController extends ApplicationController {
  static values = { url: String, active: Boolean };

  declare urlValue: string;
  declare activeValue: boolean;

  connect() {
    if (!this.element.style.backgroundImage) {
      this.useYouTubeThumbnail();
    }
    this.addNoscriptIframe();
  }

  activate() {
    if (this.activeValue) return;

    this.activeValue = true;
    const iframeEl = this.createIframe();
    this.element.append(iframeEl);

    iframeEl.focus();
  }

  useYouTubeThumbnail() {
    const regex = /(?<=\/embed\/)(.*?)(?=\?)/;
    const videoId = this.urlValue.match(regex)?.[0];
    if (videoId) {
      this.element.style.backgroundImage = `url("https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
    }
  }

  // Add the iframe within a <noscript> element so it can be indexed by search engines.
  addNoscriptIframe() {
    const iframeEl = this.createIframe();
    const noscriptEl = document.createElement("noscript");
    noscriptEl.innerHTML = iframeEl.outerHTML;
    this.element.append(noscriptEl);
  }

  createIframe() {
    const iframeEl = document.createElement("iframe");
    iframeEl.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    iframeEl.allowFullscreen = true;
    iframeEl.src = this.getUpdatedUrl();
    return iframeEl;
  }

  getUpdatedUrl() {
    let url = new URL(this.urlValue);

    url.searchParams.append("autoplay", "1");
    url.searchParams.append("playsinline", "1");
    return url.href;
  }
}
